<template>
    <div class="page">
        <div class="content">
            <van-form @submit="onSubmit">
                <van-cell-group inset>
                    <van-field v-model="formData.customerName" name="客户名称" label="客户名称" placeholder="请输入客户名称"
                        :rules="[{ required: true, message: '请输入客户名称' }]" />
                    <van-field v-model="formData.contactName" name="联系人" label="　联系人" placeholder="请输入联系人名称"
                        :rules="[{ required: true, message: '请输入联系人名称' }]" />
                    <van-field v-model="formData.productName" name="产品名称" label="产品名称" placeholder="请输入产品名称"
                        :rules="[{ required: true, message: '请输入产品名称' }]" />
                    <van-field v-model="formData.unitType" name="设备型号" label="设备型号" placeholder="请输入设备型号"
                        :rules="[{ required: true, message: '请输入设备型号' }]" />
                    <van-field v-model="formData.deviceNo" name="机身号码" label="机身号码" placeholder="请输入机身号码"
                        :rules="[{ required: true, message: '请输入机身号码' }]" />
                    <van-field v-model="formData.regionNames" is-link readonly name="area" label="地区选择"
                        placeholder="点击选择省市区" @click="showArea = true"
                        :rules="[{ required: true, message: '点击选择省市区' }]" />
                    <van-field v-model="formData.address" name="详细地址" label="详细地址" placeholder="请输入详细地址"
                        :rules="[{ required: true, message: '请输入详细地址' }]" />
                </van-cell-group>

                <div class="switch" data-flex="cross:center">
                    <p data-flex-box="1">设为默认地址</p>
                    <van-switch v-model="formData.setAsDefault" size="20" />
                </div>

                <div class="btn">
                    <van-button type="primary">立即提交</van-button>
                </div>

            </van-form>
        </div>
        <van-popup v-model:show="showArea" position="bottom">
            <van-area :area-list="areaList" @confirm="onConfirm" @cancel="showArea = false" />
        </van-popup>
        <!-- <div class="btn">
            <van-button type="primary" @click="onSubmit">立即提交</van-button>
        </div> -->
    </div>
</template>

<script>
import mix1 from '@/mixins/page'
import { uiShowLoading, uiHideLoading, uiAlert, uiConfirm } from '@/utils/ui'
import { delayAsync } from '@/utils/common'
import { Button, NumberKeyboard, Field, DatetimePicker, Overlay, Form, CellGroup, Popup, Area, Switch } from 'vant'
import MgPopup from '@/components/common/mg-popup'
import { areaList } from '@vant/area-data';

export default {
    mixins: [mix1],
    components: {
        MgPopup, Button, NumberKeyboard,
        [Switch.name]: Switch,
        [Area.name]: Area,
        [Popup.name]: Popup,
        [Form.name]: Form,
        [CellGroup.name]: CellGroup,
        [Overlay.name]: Overlay,
        [Field.name]: Field,
        [DatetimePicker.name]: DatetimePicker,
        [Button.name]: Button,
    },
    data() {
        return {
            id: 0,
            checked: false,
            username: "",
            result: '',
            showArea: false,
            areaList: areaList,
            formData: {
                customerName: '',
                contactName: '',
                productName: '',
                unitType: '',
                deviceNo: '',
                regionNames: '',
                address: '',
                setAsDefault: true,
            }
        }
    },
    methods: {
        onConfirm(e) {
            let list = e.map(it => {
                return it.name
            })
            this.formData.regionNames = list.join(',')
            this.showArea = false

        },
        async getDetail() {
            const promise = this.apiGet('my.customer.info', { id: this.id })

            let apiResult = null

            try {
                apiResult = await promise
            } catch (ex) {
                apiResult = null
            }

            if (this.isEmpty(apiResult)) {
                return
            }

            let {
                customerName,
                contactName,
                productName,
                unitType,
                deviceNo,
                regionNames,
                address,
                isDefault } = apiResult.obj

            this.formData = {
                customerName,
                contactName,
                productName,
                unitType,
                deviceNo,
                regionNames: regionNames.join(','),
                address,
                setAsDefault: isDefault == 1 ? true : false
            }
        },
        async onSubmit() {
            let {
                customerName,
                contactName,
                productName,
                unitType,
                deviceNo,
                regionNames,
                address,
                setAsDefault } = this.formData
            let data = {
                customerName,
                contactName,
                productName,
                unitType,
                deviceNo,
                regionNames: JSON.stringify(regionNames.split(',')),
                address,
                setAsDefault: setAsDefault ? 1 : 0
            }
            let promise = null

            if (this.id > 0) {
                promise = this.apiPut('my.customer.up', { id: this.id }, data)
            } else {
                promise = this.apiPost('my.customer.add', data)
            }

            uiShowLoading()
            await delayAsync(500)

            let apiResult = null

            try {
                apiResult = await promise
            } catch (ex) {
                apiResult = null
            }

            uiHideLoading()

            if (this.hasException(apiResult)) {
                return
            }

            uiAlert('操作成功', () => this.$router.go(-1))
        },

    },
    mounted() {

    },
    created() {
        let query = this.$route.query
        this.id = query.id

        if (query.id > 0) {
            this.getDetail()
        }

    }
}
</script>

<style lang="less" scoped>
.content {
    // padding: 24px;
    box-sizing: border-box;
    // background: #fff;
    margin-top: 20px;

    .van-cell {

        color: #0F0F0F !important;
        font-size: 15px;

    }

}

.switch {
    background: #fff;
    padding: 25px 30px;
    box-sizing: border-box;
    margin-top: 20px;
}

.btn {
    padding-bottom: 30px;
    text-align: center;
    margin-top: 65px;

    button {

        width: 690px;
        height: 80px;
        border-radius: 200px;
        background: #205CFF;
        border-color: #205CFF;
        margin: 0 auto;
    }
}
</style>